(() => {
  if (customElements.get('sf-card-preview')) return;

  class SoFlyCardPreview extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.trigger = this.closest('.sf-store-product, .card-wrapper');
      if (!this.trigger) return;
      this.hover = matchMedia('(hover: hover) and (pointer: fine)');
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.trigger.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'touch' && this.hover.matches) this.start();
      }, { signal });
      this.trigger.addEventListener('pointerleave', () => this.stop(), { signal });
      this.trigger.addEventListener('focusin', () => {
        if (this.trigger.matches(':focus-visible') || this.trigger.querySelector(':focus-visible')) this.start();
      }, { signal });
      this.trigger.addEventListener('focusout', event => {
        if (!this.trigger.contains(event.relatedTarget)) this.stop();
      }, { signal });
      this.trigger.addEventListener('keydown', event => {
        if (event.key === 'Escape') this.stop();
      }, { signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.stop();
      }, { signal });
      this.reducedMotion.addEventListener('change', () => this.stop(), { signal });
      this.hover.addEventListener('change', () => this.stop(), { signal });
      this.observer = new IntersectionObserver(entries => {
        if (!entries[0].isIntersecting) this.stop();
      });
      this.observer.observe(this.trigger);
    }

    start() {
      if (this.hasAttribute('data-active') || document.hidden) return;
      this.setAttribute('data-active', '');
      if (this.reducedMotion.matches) return;
      this.timer = setTimeout(() => this.play(), 150);
    }

    play() {
      if (!this.hasAttribute('data-active')) return;
      const template = this.querySelector('template');
      if (!template) return;
      const media = template.content.firstElementChild?.cloneNode(true);
      if (!media) return;
      this.media = media;
      const ready = () => {
        if (this.media === media && this.hasAttribute('data-active')) this.setAttribute('data-playing', '');
      };
      const failed = () => {
        if (this.media === media) {
          this.removeAttribute('data-playing');
          media.remove();
          this.media = null;
        }
      };
      media.addEventListener('error', failed, { once: true });
      if (media.tagName === 'VIDEO') {
        media.muted = true;
        media.addEventListener('playing', ready, { once: true });
        this.append(media);
        media.play().catch(failed);
      } else {
        media.addEventListener('load', ready, { once: true });
        media.src = media.dataset.src;
        this.append(media);
      }
    }

    stop() {
      clearTimeout(this.timer);
      this.removeAttribute('data-active');
      this.removeAttribute('data-playing');
      if (this.media?.tagName === 'VIDEO') this.media.pause();
      this.media?.remove();
      this.media = null;
    }

    disconnectedCallback() {
      this.stop();
      this.controller?.abort();
      this.observer?.disconnect();
    }
  }
  customElements.define('sf-card-preview', SoFlyCardPreview);
})();
